export const ACCEPTED = 'accepted';
export const ACCESS_TOKEN_PREFER_HEADER = 'gw_version=1';
export const ACCOUNT_PASSWORD = 'PASSWORD';
export const ACCEPT_NEW_TERMS = 'ACCEPT_NEW_TERMS';
export const ALL = 'ALL';
export const AMEX = 'AMEX';
export const AMR_OPTIONS = ['cookie', 'email_otp', 'sms_otp', 'swk'];
export const APP_JSON = 'application/json';
export const AUTH_CODE = 'x-auth-code';
export const B2CIAM_ACCEPT_NEW_TERMS = 'TERMS';
export const BATCH_MSG_TYPE = 'BATCH';
export const BRAZIL_COUNTRY_CODE = 'BR';
export const CANADA_COUNTRY_CODE = 'CA';
export const COMMON_HANDLE_TYPE = '*';
export const DATA_DELIM = '--' /* seperator within a message */;
export const DEACTIVATE_SYS_IFRAME = 'height: 0px; width: 0px; display: none;';
export const DEACTIVATE_SYS_WRAPPER =
  'visibility: hidden; position: fixed; height: 1px; width: 1px; left: 0px; bottom: 0px;';
export const DEBIT = 'debit';
export const DEFAULT_USER_TYPE = 'email';
export const DFP_SESSION_ID = 'dfpSessionId';
export const ELECTRON = 'ELECTRON';
export const ERM_ACTIVITY_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:activity_ref';
export const EU_NON_PRECHECK_COUNTRIES = ['ES', 'FR', 'GB', 'IE', 'PL'];
export const FORM_URL_ENCODED = 'application/x-www-form-urlencoded';
export const FULL = 'FULL';
export const INVALID_GRANT = 'invalid_grant';
export const MA = 'MA';
export const MASTERCARD = 'MASTERCARD';
export const MESSAGE_DELIM = '+-+-+' /* seperator for multiple messages */;
export const NOTEXIST = 'NOTEXIST';
export const NOT_ACCEPTED = 'not_accepted';
export const NOT_VERIFIED = 'NOT_VERIFIED';
export const NS_VDCP_MOBILE_WEB = 'vdcp-mobile-web';
export const NS_VDCP_WEB = 'vdcp-web';
export const NS_VXO_WEB = 'vxo-web';
export const OTP_SUCCESS_VALIDATION_CHANNEL = 'x-via-hint_vch';
export const PASSWORD_TYPE = 'OTP';
export const PRESENT = 'PRESENT';
export const RECOGNIZED_API_LOCKOUT_ERROR = 'invalid_grant_loginlockout';
export const SUCCESS = 'success';
export const SYSTEM_DEFAULT_PROFILE = 'SYSTEMDEFAULT';
export const UNDEFINED = 'undefined';
export const USERNOTALLOWED = 'USERNOTALLOWED';
export const VALID_COMBO_CARD_TYPES = ['A', 'C']; // There are other type as N/null - for not a combo card.
export const NOTPRESENT = 'NOTPRESENT';
export const VISA_CONSUMER_ID_TYPE = 'EMAIL';
export const VISA = 'VISA';
export const X_CORRELATION_ID = 'X-CORRELATION-ID';
export const X_THMID = 'X-THMID';
export const X_USER_CRED = 'X-USER-CRED';

export const B2CIAM_ENUMS = {
  ABANDON: 'ABANDON',
  ACCOUNT_LOCKED: 'account_locked',
  ACTIVITY_REF_ERM: 'activity_ref',
  ACTIVITY_REF_SSI: 'activity_ref_ssi',
  DEVICE_LOCKED: 'device_locked',
  DEVICE_LOCKED_VMG_ERROR: 'VMG-00231',
  GUEST: 'GUEST',
  ID_LOOKUP_ENROLL: 'ENROLL',
  RECOGNIZED_FULL: 'FULL',
  RECOGNIZED_PARTIAL: 'PARTIAL'
};

export const BRANDING = {
  SRC: 'SRC',
  VCO: 'VCO'
};

export const CARD_ENROLL_EVENTS = {
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  PENDING: 'PENDING',
  PENDING_AVS: 'PENDING_AVS',
  PENDING_CONSUMER_IDV: 'PENDING_CONSUMER_IDV'
};

export const CARD_ENROLL_FAILURES = {
  ACCT_INACCESSIBLE: 'ACCT_INACCESSIBLE',
  CARD_ADD_FAILED: 'CARD_ADD_FAILED',
  CARD_MISSING: 'CARD_MISSING',
  INVALID_SRC_CLIENT_ID: 'INVALID_SRC_CLIENT_ID'
};

export const ENROLLCARD_NAMESPACES = {
  SRC: 'src',
  SRC_XO: 'src-xo'
};

/* To set whether user flows in standard/ssi/erm */
export const FLOW_TYPE = {
  ERM: 'erm',
  SSI: 'ssi',
  STD: 'standard'
};

export const ID_TOKEN_TYPE_HINT = [
  'urn:ext:oauth:token-type-hint:id_token',
  'urn:ext:ietf:params:oauth:response-type:id_token'
];

export const SRCI_ACTION_CODE = {
  AUTH_FAILED: 'AUTH_FAILED',
  AUTH_SKIPPED: 'AUTH_SKIPPED',
  NEW_USER: 'NEW_USER'
};

export const THM_ORG_ID = {
  NON_PROD: 'ay3xz4ma',
  PROD: 'ge4f5xfn'
};

// F11669 - usernameType values, used as param to Visa lookupUserName api
export const USERNAME_TYPE = {
  EMAIL: 'EMAIL',
  REMEMBER_ME: 'REMEMBER_ME'
};
